var EF = require('ef/ef');
var View = require('views/base/view');
var LocaleService = require('services/locale-service');

var TranscriptView = View.extend({
  autoRender: true,
  autoAttach: true,
  region: 'siteTranscript',
  template: require('views/transcript/templates/transcript'),
  initialize: function(options) {
    var self = this;
    this.model.set('transcript', this.model.get('transcriptNarration'));
    View.prototype.initialize.apply(this, arguments);
  }

});

module.exports = TranscriptView;
